import { render } from "./pills.vue?vue&type=template&id=5cce2976&scoped=true"
import script from "./pills.vue?vue&type=script&lang=js"
export * from "./pills.vue?vue&type=script&lang=js"

import "./pills.vue?vue&type=style&index=0&id=5cce2976&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cce2976"]])

export default __exports__